export enum BookingStatus {
  PENDING_PAYMENT = "pending_payment",
  CONFIRMED = "confirmed",
  COMPLETED = "completed",
  EXPIRED = "expired",
  CANCELLED_BY_STUDENT = "cancelled_by_student",
  CANCELLED_BY_INSTRUCTOR = "cancelled_by_instructor",
  CANCELLED_BY_ADMIN = "cancelled_by_admin",
  DISPUTED = "disputed",
  REFUNDED = "refunded",
}
